import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const Container = styled.div`
  background: #DEDEDE;
  border-bottom: 2px solid #fff;
  height: 70px;
  @media (max-width: 540px) {
    overflow-x: scroll;
    overflow-y: hidden;
  }
  a {
    border-left: 1px solid #fff;
    display: flex;
    height: 100%;
    width: 100%;
    min-width: 220px;
    padding: 0 20px;
    text-align: center;
    align-items: center;
    justify-content: center;
    font: 600 16px Montserrat;
    color: #40403F;
    text-decoration: none;
    border-bottom: 4px solid transparent;
    transition: all 0.3s;
    @media (min-width: 540px) {
      &:hover {
        background: #fff;
      }
    }
    &:last-child {
      border-right: 1px solid #fff;
    }
    &.active {
      border-bottom: 4px solid #F1A857;
    }
    i {
      background-size: contain;
      height: 30px;
      width: 30px;
      display: inline-block;
      margin-right: 14px;
    }
  }
`

const BarWhereFind = ({active}) => {
  const produtos = active === 'produtos' ? 'active' : '';
  const representantes = active === 'representantes' ? 'active' : '';
  const compensados = active === 'compensados' ? 'active' : '';
  return (
    <Container>
      <div className="wrapper flex">
        <Link to="/onde-encontrar" className={ produtos }>
          MDF
        </Link>
        <Link to="/onde-encontrar/compensados" className={ compensados }>
          Compensados
        </Link>
        <Link to="/onde-encontrar/representantes" className={ representantes }>
          Representantes
        </Link>
      </div>
    </Container>
  )
}

export default BarWhereFind;
